import { get } from 'lodash'

const isBasic = () => {

  const type = get(window, 'state.user.type')

  return type === 'Admin' || type === 'Basic+' || type === 'Basic' || type === 'Advanced' || type === 'Premium'

}

export default isBasic
